export enum DataType {
  Bag = 'bag',
  BRK = 'brk',
  Data = 'data',
  Dataset = 'dataset',
  Catalog = 'catalogus',
  Gebieden = 'gebieden',
  HR = 'hr',
  Indicatoren = 'indicatoren',
  Monumenten = 'monumenten',
  Map = 'map',
  Search = 'search',
}

export enum DataSubtype {
  Buurt = 'buurt',
  Buurten = 'buurten',
  BouwBlokken = 'bouwblokken',
  Catalog = 'catalogus',
  Complexen = 'complexen',
  Dataset = 'dataset',
  GGWGebieden = 'ggwgebieden',
  StedelijkGebiedProjectOfBelangen = 'stedelijkgebiedprojectofbelangen',
  Ligplaatsen = 'ligplaatsen',
  MaatschappelijkeActiviteiten = 'maatschappelijkeactiviteiten',
  MapLayer = 'map-layer',
  Monumenten = 'monumenten',
  Nummeraanduiding = 'nummeraanduiding',
  Object = 'object',
  OpenbareRuimtes = 'openbareruimtes',
  Panden = 'panden',
  Stadsdelen = 'stadsdelen',
  Standplaatsen = 'standplaatsen',
  Subject = 'subject',
  Verblijfsobjecten = 'verblijfsobjecten',
  Vestigingen = 'vestigingen',
  Wijken = 'wijken',
  Woonplaats = 'woonplaats',
}

export interface DataIdentifier {
  id: string
  subtype: DataSubtype
  type: DataType
}

export interface DataResult {
  id: string
  type: DataType
  label: string
  subType: DataSubtype
  name?: string
  __typename: 'DataResult'
}
